/**
 * 分享
 */

require('./share.css');
var emshare = require('./emshare');


emshare.init({
    url: '',
    title: '',
    des: '',
    from: '东方财富网'
});

function stopscroll(e){
	e.preventDefault();
}

var sharebox = {
	isshow: false,
	init: function (){
			
	},
	bind: function (){
			
	},
	show: function (shareobj){
		emshare.shareobj.title = shareobj.title;
		emshare.shareobj.url = shareobj.url;
		emshare.shareobj.des = shareobj.des;

		if (this.isshow) {
			this.sharehtml.show();
		}
		else{
			this.sharehtml = $('<div id="sharebox"><div class="shareshadow"></div><div class="share"><div class="sharetitle"><div>分享至</div></div><div class="sharebtns"><div class="sharebtn pybbtn"><div class="shareimg pyqimg"></div>朋友圈</div><div class="sharebtn wxhybtn"><div class="shareimg wxhyimg"></div>微信好友</div><div class="sharebtn sinabtn"><div class="shareimg sinaimg"></div>新浪微博</div><div class="sharebtn qqhybtn"><div class="shareimg qqhyimg"></div>QQ好友</div><div class="sharebtn qqzoombtn"><div class="shareimg qqzoom"></div>QQ空间</div></div><div class="sharecancel">取消</div></div></div>');
			
			if(emshare.isqqbrowser || emshare.isucbrowser){
				$('.pybbtn', this.sharehtml).add('.wxhybtn', this.sharehtml).add('.qqhybtn', this.sharehtml).css('display', 'inline-block');
			}

			$('.sinabtn', this.sharehtml).on('click', function (){
				emshare.weibo();
			});
			$('.qqzoombtn', this.sharehtml).on('click', function (){
				emshare.qqzoom();
			});
			$('.pybbtn', this.sharehtml).on('click', function (){
				emshare.wxcircle();
			});
			$('.wxhybtn', this.sharehtml).on('click', function (){
				emshare.wzfriend();
			});
			$('.qqhybtn', this.sharehtml).on('click', function (){
				emshare.qqfriend();
			});


			$('body').append(this.sharehtml);

			$('.shareshadow', this.sharehtml).add('.sharecancel', this.sharehtml).on('click', function (){
				this.sharehtml.hide();
				document.body.style.overflow = 'visible';

				$(window).off('touchmove', stopscroll);

				return false;
			}.bind(this));

			this.isshow = true;		
		}
		var top = document.body.scrollTop;
        this.sharehtml.css('top', top);
		$('body').css({overflow:'hidden'});

		$(window).on('touchmove', stopscroll);
		//window.scrollTo(0, top);

	}

}


module.exports = sharebox;


//////////////////
// WEBPACK FOOTER
// ./dev/modules/share/share.js
// module id = 13
// module chunks = 11